import React from 'react';
import { Icon } from '@iconify/react';
import '../../styles/app-ui.scss';

const AppQuantityStepper = ({
  value = 0,
  min = 0,
  max,
  onChange,
  disabled = false,
  ariaLabel = 'Quantité',
}) => {
  const current = Number.isFinite(Number(value)) ? Number(value) : 0;
  const atMin = current <= min;
  const atMax = max != null && current >= max;

  return (
    <div className="app-qty" role="group" aria-label={ariaLabel}>
      <button
        type="button"
        className="app-qty__btn"
        aria-label="Moins"
        disabled={disabled || atMin}
        onClick={() => onChange?.(Math.max(min, current - 1))}
      >
        <Icon icon="lucide:minus" width={16} height={16} aria-hidden />
      </button>
      <span className="app-qty__value">{current}</span>
      <button
        type="button"
        className="app-qty__btn"
        aria-label="Plus"
        disabled={disabled || atMax}
        onClick={() => onChange?.(max != null ? Math.min(max, current + 1) : current + 1)}
      >
        <Icon icon="lucide:plus" width={16} height={16} aria-hidden />
      </button>
    </div>
  );
};

export default AppQuantityStepper;
